import {DOCUMENT, isPlatformBrowser, ViewportScroller} from '@angular/common';
import {AfterViewInit, ApplicationRef, Compiler, Component, ElementRef, Inject, Injector, OnDestroy, OnInit, PLATFORM_ID, Renderer2, ViewChild, ViewContainerRef} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { LazyLoad } from '@app/helpers/lazyload';
import { DeepLinkType } from '@app/models/deep-link.model';
import { UrlService } from '@app/services/url.service';
import { environment } from '@env/environment';
import { FingerprintService } from '../services/fingerprint.service';
import { TrackingComponent } from '@app/shared/components/tracking/tracking.component';
import {ExternalReviews, Review} from '@app/models/external-reviews.model';
import {Category} from '@app/market-seo/models/category.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PaymentConfirmationComponent} from '@app/market-seo/payment-confirmation/payment-confirmation.component';
import {StorageService} from '@app/services/storage.service';
import {ProductProviderEnum} from '@app/marketplace/core/enum/productProvider';
const lazyLoad = LazyLoad;

@Component({
  selector: 'app-market-seo',
  templateUrl: './market-seo.component.html',
  styleUrls: ['./market-seo.component.css']
})
export class MarketSeoComponent extends TrackingComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('recommended_products_section') recommended_products_section: ElementRef;
  @ViewChild('stores_section') stores_section: ElementRef;
  element: any;
  loadRecommendedProducts = false;
  loadStores = false;
  title = 'Cubatel Market | Tu tienda de envíos a Cuba';
  description = '¡Somos el Amazon cubano! Descubre nuestras tiendas online para comprar en Cuba desde el exterior. Entregamos a domicilio en todas las provincias cubanas.';
  keywords = 'tiendas online para envíos a cuba, amazon cubano, amazon en cuba, tiendas de envíos a cuba, tienda de envíos a cuba, envío a cuba online, tiendas online con envío a cuba, compras online en cuba desde el exterior, tiendas online en cuba para comprar desde el exterior, tiendas de envíos a cuba online, tiendas virtuales en cuba para comprar desde el exterior, compras online para cuba desde el exterior, tiendas online para comprar en cuba desde el exterior, compras desde el exterior para cuba';

  DeepLinkType = DeepLinkType;
  ProviderType = ProductProviderEnum;

  turnOnShein = environment.turn_on_shein;
  turnOnAmazon = environment.turn_on_amazon;
  turnOnWalmart = environment.turn_on_walmart;
  turnOnHomeDepot = environment.turn_on_walmart;
  turnOnBestBuy = environment.turn_on_bestbuy;

  private _componentRef;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private urlService: UrlService,
    private titleService: Title,
    private metaService: Meta,
    private fingerprintService: FingerprintService,
    private storageService: StorageService,
    private _injector: Injector,
    private _viewRef: ViewContainerRef,
    private _renderer: Renderer2,
    private _compiler: Compiler,
    private modalService: NgbModal,
    private _applicationRef: ApplicationRef,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId,
    private scroller: ViewportScroller
  ) { super(urlService, fingerprintService, storageService, route, 'stu_btn_market'); }

  ngAfterViewInit(): void {
    }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      /*setTimeout(() => {
            this.scroller.scrollToAnchor('sshipping-section');
            }, 1000);*/
      document.addEventListener('scroll', (e) => {
        if (!this.loadStores && (this.router.url == '/market' || this.router.url == '/market#sshipping-section')) {
          this.loadModule(import('@app/market-seo/stores-section/stores-section.module'), 'stores_section');
          this.loadStores = true;
        }
        if (!this.loadRecommendedProducts && (this.router.url == '/market' || this.router.url == '/market#sshipping-section')) {
          this.loadModule(import('@app/market-seo/recommended-products-section/recommended-products-section.module'), 'recommended_products_section');
          this.loadRecommendedProducts = true;
        }
      }, {
        passive: true
      });
    }

    this.metaService.updateTag({
      name: 'description',
      content: this.description,
    });
    this.metaService.updateTag({ name: 'keywords', content: this.keywords });
    this.metaService.updateTag({ name: 'robots', content: 'all' });
    this.metaService.updateTag({ property: 'og:title', content: this.title });
    this.metaService.updateTag({
      property: 'og:description',
      content: this.description,
    });
    this.metaService.updateTag({
      property: 'og:url',
      content: `${environment.host}${this.router.url}`,
    });
    this.route.queryParams.subscribe(result => {
      if (result['rsp']) {
        this.paymentConfirmation();
      }
    });
    this.titleService.setTitle(this.title);
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }

  private loadModule(importModule: Promise<any>, element: string) {
    importModule
      .then((module) => module[Object.keys(module)[0]])
      .then((module) => this._compiler.compileModuleAsync(module))
      .then((factory) => {
        const moduleRef = factory.create(this._injector);
        const component = (moduleRef as any)._bootstrapComponents[0];
        this._componentRef = moduleRef.componentFactoryResolver.resolveComponentFactory(component).create(this._injector, [], null, moduleRef);
        // Set component input variables
        // this.storageService.loadLoginSubject.next(false);
        this._applicationRef.attachView(this._componentRef.hostView);
        this._applicationRef.attachView(this._componentRef.hostView);
        const elementRef = element === 'recommended_products_section' ? this.recommended_products_section :
          element === 'stores_section' ? this.stores_section : undefined;
        if (elementRef !== undefined) {
          this._renderer.appendChild(elementRef.nativeElement, this._componentRef.location.nativeElement);
        }
      });
  }

  paymentConfirmation() {
    const modalRef = this.modalService.open(PaymentConfirmationComponent, {size: 'md'});
    modalRef.result.then((result: any) => {
      if (result.products) {
        this.router.navigate(['market/productos-compras-cuba-online']);
      } else {
        this.router.navigate(['market/pedidos']);
      }
    }).catch(() => {});
  }

  ngOnDestroy(): void {
    this.loadStores = false;
    this.loadRecommendedProducts = false;
  }
}
